import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import MeasureUnitHelper from "@Scripts/Infrastructure/MeasureUnitHelper";
import DataHelper from "@Scripts/Common/DataHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CatalogueProductDetailInformation" })
export default class CatalogueProductDetailInformation extends Vue {
    public localizer: any = Localizer;
    public measureUnitHelper: any = MeasureUnitHelper;
    public dataHelperConfiguration: any = null;
    public product: any = null;
    public resources: any = null;
    public imageInfos: any = null;
    public isLoading: boolean = true;
    public isDownloading: boolean = false;

    @Prop() readonly culture: any;
    @Prop() readonly familyCode: any;
    @Prop() readonly orderCode: any;
    @Prop() readonly productViewPdfUrl: string;
    @Prop() readonly productPdfUrl: any;

    get measureUnits() {
        return this.$store.getters["measureUnitStore/measureUnits"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.dataHelperConfiguration = DataHelper.getConfigurationByCulture(this.culture);

        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        const response = (await Axios.post(this.routes.Catalogue_GetCatalogueProductDetailInfo, { familyCode: this.familyCode, orderCode: this.orderCode })).data;
        this.resources = response.resources;
        this.imageInfos = response.imageInfos;
        this.product = response.product;

        this.isLoading = false;
    }

    public openPdfUrl() {
        GTagHelper.sendEvent("click", "product_accessory", "technical_sheet");
        window.open(this.productViewPdfUrl, '_blank');
    }

    public shiftFirstImage(array: any[], assetType: string): any[] {
        let arr = array.filter(x => x.assetType === assetType);
        arr.shift();
        return arr;
    }

    public isNullOrEmptyTrim(str: string): boolean {
        return !str || str.trim().length === 0;
    }

    public formatNumber(x: number, min: number = null) {
        this.dataHelperConfiguration.thousandsSeparator = "";

        if (min) {
            this.dataHelperConfiguration.decimalCount = min;
        }

        return DataHelper.convertNumberToString(x, this.dataHelperConfiguration, min ? true : false);
    }

    public getCultureValue(attributeName, value) {
        const resource = this.resources.find(x => x.attributeName === attributeName && x.code === value);
        return resource?.cultureItems.find(x => x.culture === this.culture)?.value || value;
    }

    public getCultureValues(attributeName, values) {
        if (values !== null) {
            return values.map(x => this.getCultureValue(attributeName, x)).join(', ');
        } else {
            return null;
        }
    }

    public async pdfDownload() {
        if (!this.isDownloading) {
            this.isDownloading = true;

            let response = await Axios.post(this.productPdfUrl, null, { responseType: "blob" });
            if (response) {
                const fileName = response.headers["x-filename"];

                let binaryData = [];
                binaryData.push(response.data);

                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(new Blob(binaryData, { type: response.data.type }));
                link.download = fileName;
                link.click();

                GTagHelper.sendEvent("file_download", "product_interaction", "technical_sheet");
            }

            this.isDownloading = false;
        }
    }
};